class AnalyticsEvent {
	constructor(simulatedURL, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent, isMixPanelEvent) {
		this.className = 'AnalyticsEvent';
		this.simulatedURL = simulatedURL;
		this.isLocalAnalyticsEvent = (isLocalAnalyticsEvent) ? isLocalAnalyticsEvent : false;
		this.isGoogleAnalyticsVisit = isGoogleAnalyticsVisit;
		this.isGoogleAnalyticsEvent = isGoogleAnalyticsEvent;
		this.isMixPanelEvent = isMixPanelEvent;
		this.extraParams = "";
		this.fullURL = "";
		this.eventType = "ANALYTICS_EVENT";
		this._gaEventSet = {};
		this._mpEventSet = {};
		this.userInput = simulatedURL;
		this.userId = userId;
		this.userDevice = device;
		this.append = this.append.bind(this)
		this.gaTracker = '';
		this.mpTracker = '';
	}

	append(uId, d) {
		this.extraParams = 'user=' + uId;
		this.extraParams += '&device=' + d;
	}

	ucfirst(str) {
		// console.log(this.constructor.name, "ucfirst()", str);
		return str ? str.charAt(0).toUpperCase() + str.substr(1) : "";
	}
}

export default AnalyticsEvent;


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/AnalyticsEvent.js